import { ArrowRight, CalendarDays } from "lucide-react";
import { SmartLink } from "@/components/SmartLink";
import { Prose } from "@/components/Prose";
import { abs, formatDate } from "@/lib/api";

export const AnnouncementList = ({ items }) => (
  <ul className="divide-y divide-line rounded-md border border-line bg-white" data-testid="announcement-list">
    {items.map((a) => (
      <li key={a.slug} className="p-5 sm:p-6" data-testid={`announcement-item-${a.slug}`}>
        {a.date && (
          <p className="mb-2 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-redDark" data-testid="announcement-date">
            <CalendarDays className="h-4 w-4" aria-hidden="true" />
            <time dateTime={a.date}>{formatDate(a.date)}</time>
          </p>
        )}
        <h3 className="text-lg font-semibold leading-snug">{a.title}</h3>
        {a.event_label && <p className="mt-1.5 text-[15px] font-semibold text-ink-soft">{a.event_label}</p>}
        {a.summary && <p className="mt-1.5 text-[15px] text-ink-muted">{a.summary}</p>}
        {!a.link && !a.summary && a.body_html && <Prose html={a.body_html} className="mt-2 text-[15px]" />}
        {!a.link && a.documents?.length > 0 && (
          <ul className="mt-2 space-y-1">
            {a.documents.map((d) => (
              <li key={d.slug}><a href={abs(d.download_url)} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-navy hover:underline">{d.title} ({d.ext})</a></li>
            ))}
          </ul>
        )}
        {a.link && (
          <SmartLink item={{ to: a.link }} testId={`announcement-link-${a.slug}`}
            className="group mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:underline">
            {a.link.startsWith("/belgeler/") ? "Belgeyi görüntüle" : "İlanın tamamı"}
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
          </SmartLink>
        )}
      </li>
    ))}
  </ul>
);
